import {
  Box,
  JustifyContent,
  AlignItems,
  P,
  TypePreset,
  Link,
  ButtonVariant,
  ButtonSize,
  XYGrid,
  TextAlign,
} from "@gocardless/flux-react";
import Image from "next/image";
import { Trans } from "@lingui/macro";

import NotFoundImage from "src/assets/png/404.png";
import { Route } from "src/components/routing";
import { getRouteURL } from "src/common/routing";
import { useSupportCentreUrl } from "src/hooks/useSupportCentreUrl";
import { LogoHeader } from "src/components/layout/core/Headers/LogoHeader";
import { SingleFixedLayout } from "src/components/layout/core/SingleFixedLayout";

const NotFound: React.FC = () => {
  const supportCentreUrl = useSupportCentreUrl();

  return (
    <SingleFixedLayout
      header={{
        content: <LogoHeader />,
      }}
    >
      <XYGrid
        width={["90%", null, "700px"]}
        height={["610px", "268px"]}
        columnGap={1}
        rowGap={1}
        templateAreas={[
          `
            " title title title"
            " desc desc desc "
            " image image image "
            " action action action"
          `,
          `
            "image title title title"
            "image desc desc desc"
            "image action action action"
          `,
        ]}
        autoColumns="1fr"
        autoRows="1fr"
      >
        <Box
          gridArea="image"
          layout="flex"
          height="100%"
          alignItems={AlignItems.Center}
          justifyContent={JustifyContent.Center}
        >
          <Image src={NotFoundImage} alt="" width={84} height={268} />
        </Box>
        <Box gridArea="title">
          <P
            preset={TypePreset.LongForm_04}
            size={[11, 12]}
            lineHeight={12}
            textAlign={[TextAlign.Center, TextAlign.Left]}
          >
            <Trans id="errors.404.cant.find.page">
              Sorry we can&apos;t find that page
            </Trans>
          </P>
        </Box>
        <Box gridArea="desc">
          <P
            preset={TypePreset.Body_01}
            size={[3, 4]}
            textAlign={[TextAlign.Center, TextAlign.Left]}
          >
            <Trans id="errors.404.the-page-may-have-moved">
              The page you&apos;re looking for may have moved, or perhaps the
              address is incorrect.
            </Trans>
          </P>
        </Box>
        <Box gridArea="action" alignSelf={AlignItems.End} spaceBelow={0.25}>
          <XYGrid
            templateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)"]}
            rowGap={0.5}
            columnGap={0.5}
          >
            <Link
              href={getRouteURL({
                route: Route.Home,
              })}
              variant={ButtonVariant.PrimaryOnLight}
              size={ButtonSize.Sm}
            >
              <Trans id="errors.404.return.home">Return home</Trans>
            </Link>
            <Link
              href={supportCentreUrl}
              variant={ButtonVariant.SecondaryOnLight}
              size={ButtonSize.Sm}
              target="_blank"
            >
              <Trans id="errors.404.contact.support">Contact support</Trans>
            </Link>
          </XYGrid>
        </Box>
      </XYGrid>
    </SingleFixedLayout>
  );
};

export default NotFound;
